.section {
  padding-block: clamp(56px, 8vw, 96px);
}

.head {
  max-width: 62ch;
  margin-bottom: clamp(32px, 5vw, 48px);
}
.head h2 {
  margin-top: 10px;
  font-size: var(--step-4);
}
.head p {
  margin-top: 14px;
  font-size: var(--step-1);
  color: var(--text-secondary);
  max-width: 58ch;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}
@media (max-width: 780px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 520px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  padding: 24px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.iconRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.icon {
  width: 40px;
  height: 40px;
  color: var(--action);
}
.number {
  font-size: var(--step--1);
  font-weight: 700;
  color: var(--color-charcoal-300);
}

.card h3 {
  font-size: 1.02rem;
  font-weight: 700;
}
.card p {
  font-size: 0.9rem;
  color: var(--text-secondary);
}
